/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconMoySklad16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconMoySklad16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.951 13.505c1.78 0 3.124-2.316 4.33-4.845.58-1.226 1.121-2.51 1.662-3.6C9.538 3.853 10.147 3 10.893 3c.632 0 1.227.51 1.82 1.31C13.94 5.973 15 8.785 15 10.63c0 1.544-.796 2.875-2.426 2.875H2.951Z"
                fill="#64CDFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.28 8.66C6.056 6.196 5.503 4.389 4.422 4.389c-.671 0-1.428.704-2.112 1.858C1.577 7.472 1 9.2 1 11.06c0 1.468.719 2.445 1.95 2.445 1.778 0 3.123-2.316 4.33-4.845Z"
                fill="#2855AF"
            />
        </SVGContainer>
    );
});

const IconMoySklad24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconMoySklad24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.064 20.508c2.796 0 4.91-3.64 6.804-7.614.912-1.926 1.763-3.945 2.613-5.656C14.415 5.34 15.373 4 16.545 4c.994 0 1.928.802 2.859 2.06 1.93 2.61 3.597 7.03 3.597 9.929 0 2.428-1.25 4.519-3.812 4.519H4.064Z"
                fill="#64CDFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.868 12.894c-1.92-3.871-2.79-6.712-4.488-6.712-1.056 0-2.244 1.107-3.32 2.92C1.907 11.028 1 13.744 1 16.666c0 2.308 1.13 3.843 3.064 3.843 2.795 0 4.909-3.64 6.804-7.614Z"
                fill="#2855AF"
            />
        </SVGContainer>
    );
});

export const IconMoySklad = forwardRef<SVGSVGElement, IconBaseProps>(function IconMoySklad(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconMoySklad16 {...iconProps} />;
        case '24':
            return <IconMoySklad24 {...iconProps} />;
        default:
            return <IconMoySklad24 {...iconProps} />;
    }
});
